(function () {
  'use strict';

  var SECTION_ID = 'template--18038337994846__main';
  var PREFETCH_TTL_MS = 30000;
  var PREFETCH_PREFIX = 'wth_bridge_prefetch:';
  var MAX_PREFETCH_ENTRIES = 2;
  var inFlight = {};

  // Each prefetch entry is a full 250-product HTML page (~hundreds of KB).
  // Without cleanup, a browsing session can fill the ~5MB sessionStorage quota
  // and make every later setItem (including wth_fitment_vehicle) fail
  // silently. Sweep expired entries at boot and cap how many can coexist.
  function listPrefetchKeys() {
    var keys = [];
    try {
      for (var i = 0; i < sessionStorage.length; i++) {
        var k = sessionStorage.key(i);
        if (k && k.indexOf(PREFETCH_PREFIX) === 0) keys.push(k);
      }
    } catch (_) {}
    return keys;
  }

  function entryTime(key) {
    try {
      var parsed = JSON.parse(sessionStorage.getItem(key) || 'null');
      return parsed && typeof parsed.t === 'number' ? parsed.t : 0;
    } catch (_) {
      return 0;
    }
  }

  function sweepPrefetchEntries(keepKey) {
    var keys = listPrefetchKeys();
    var now = Date.now();
    var live = [];
    keys.forEach(function (k) {
      if (k === keepKey) return;
      var t = entryTime(k);
      if (!t || now - t > PREFETCH_TTL_MS) {
        try { sessionStorage.removeItem(k); } catch (_) {}
      } else {
        live.push({ key: k, t: t });
      }
    });
    // Evict oldest live entries beyond the cap (the keepKey slot counts as one).
    var budget = MAX_PREFETCH_ENTRIES - (keepKey ? 1 : 0);
    if (live.length > budget) {
      live.sort(function (a, b) { return b.t - a.t; });
      live.slice(Math.max(0, budget)).forEach(function (entry) {
        try { sessionStorage.removeItem(entry.key); } catch (_) {}
      });
    }
  }

  function storePrefetchEntry(key, html) {
    sweepPrefetchEntries(key);
    var value = JSON.stringify({ html: html, t: Date.now() });
    try {
      sessionStorage.setItem(key, value);
    } catch (_) {
      // Likely quota — drop ALL bridge entries and retry once; never let the
      // prefetch cache poison storage for fitment-critical keys.
      listPrefetchKeys().forEach(function (k) {
        try { sessionStorage.removeItem(k); } catch (_) {}
      });
      try { sessionStorage.setItem(key, value); } catch (_) {}
    }
  }

  function normalizeParamName(name) {
    var raw = String(name || '');
    if (window.WTHTirePublicUrl && typeof window.WTHTirePublicUrl.paramName === 'function') {
      return window.WTHTirePublicUrl.paramName(raw);
    }
    var privatePrefix = 'filter.p.m.' + 'pmc' + '_tire.';
    if (raw.indexOf(privatePrefix) === 0) return 'filter.p.m.tire.' + raw.slice(privatePrefix.length);
    return raw;
  }

  function getRootUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function scopedKind(params) {
    var found = '';
    params.forEach(function (_value, key) {
      var k = normalizeParamName(key);
      if (k.indexOf('filter.p.m.wheel.') === 0) found = found || 'wheel';
      if (k.indexOf('filter.p.m.tire.') === 0) found = found || 'tire';
    });
    return found;
  }

  function collectionKindFromUrl(url) {
    var path = String(url.pathname || '').toLowerCase();
    if (path.indexOf('/collections/wheels') !== -1) return 'wheel';
    if (path.indexOf('/collections/tires') !== -1) return 'tire';
    return 'mixed';
  }

  function readVehicle() {
    try { return JSON.parse(sessionStorage.getItem('wth_fitment_vehicle') || 'null'); }
    catch (_) { return null; }
  }

  function appendVehicleDefaults(params, collectionKind) {
    var v = readVehicle();
    if (!v) return;
    if (collectionKind === 'tire') {
      if (v.tireSize && !params.has('filter.p.m.tire.size')) {
        params.append('filter.p.m.tire.size', v.tireSize);
      }
      if (v.tireSizeRear && v.tireSizeRear !== v.tireSize) {
        params.append('filter.p.m.tire.size', v.tireSizeRear);
      }
    } else if (collectionKind === 'wheel') {
      if (v.boltPattern && !params.has('filter.p.m.wheel.bolt_pattern')) {
        params.append('filter.p.m.wheel.bolt_pattern', v.boltPattern);
      }
      if (v.rimDiameter && !params.has('filter.p.m.wheel.diameter')) {
        var dVal = (v.rimDiameter % 1 === 0) ? v.rimDiameter + '.0' : String(v.rimDiameter);
        params.append('filter.p.m.wheel.diameter', dVal);
        if (v.rimDiameterRear && Math.round(parseFloat(v.rimDiameterRear) * 2) / 2 !== Math.round(parseFloat(v.rimDiameter) * 2) / 2) {
          var rdVal = (v.rimDiameterRear % 1 === 0) ? v.rimDiameterRear + '.0' : String(v.rimDiameterRear);
          params.append('filter.p.m.wheel.diameter', rdVal);
        }
      }
    }
    if (v.fmk && !params.has('fmk')) params.append('fmk', v.fmk);
  }

  function buildBridgeUrl(kind, filters) {
    if (!kind || (kind !== 'tire' && kind !== 'wheel')) return '';
    var bridge = new URL(getRootUrl() + 'search', window.location.origin);
    bridge.searchParams.set('q', '*');
    bridge.searchParams.set('type', 'product');
    bridge.searchParams.set('options[unavailable_products]', 'last');
    bridge.searchParams.set('wth_bridge_type', kind);
    if (filters && typeof filters.forEach === 'function') {
      filters.forEach(function (value, key) {
        bridge.searchParams.append(normalizeParamName(key), value);
      });
    }
    // Scope the search to the collection's product type so the vendor (and other)
    // facets list ONLY this type's brands. Without it, q=* spans the whole catalog
    // and wheel brands leak into the tire rail (and vice versa) — wth_bridge_type only
    // picks which rail to render, it does NOT filter Shopify. product_type values are
    // lowercase 'tire'/'wheel' (== kind).
    bridge.searchParams.set('filter.p.product_type', kind);
    if (kind === 'wheel' || kind === 'tire') bridge.searchParams.set('per_page', '250');
    bridge.searchParams.set('section_id', SECTION_ID);
    return bridge.toString();
  }

  function buildBridgeUrlFromCollectionUrl(href) {
    var target;
    try { target = new URL(href, window.location.origin); }
    catch (_) { return ''; }
    if (target.origin !== window.location.origin) return '';
    if (target.pathname.indexOf('/collections/') === -1) return '';

    var collectionKind = collectionKindFromUrl(target);
    var bridgeParams = new URLSearchParams();
    target.searchParams.forEach(function (value, key) {
      var k = normalizeParamName(key);
      if (k === 'filter.p.product_type' || k === 'q' || k === 'type' || k === 'options[unavailable_products]' || k === 'section_id') return;
      if (k.indexOf('filter.') === 0 || k === 'page' || k === 'per_page' || k === 'fmk') {
        bridgeParams.append(k, value);
      } else if (k === 'sort_by' && value !== 'best-selling') {
        bridgeParams.set(k, value);
      }
    });

    if (!scopedKind(bridgeParams)) appendVehicleDefaults(bridgeParams, collectionKind);

    var kind = scopedKind(bridgeParams);
    if (!kind) return '';
    if ((collectionKind === 'tire' || collectionKind === 'wheel') && kind !== collectionKind) return '';
    return buildBridgeUrl(kind, bridgeParams);
  }

  function hasFreshPrefetch(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return false;
      var parsed = JSON.parse(raw);
      return !!(parsed && parsed.html && typeof parsed.t === 'number' && Date.now() - parsed.t <= PREFETCH_TTL_MS);
    } catch (_) {
      return false;
    }
  }

  function prefetchBridgeUrl(bridgeUrl) {
    if (!bridgeUrl) return;
    var key = PREFETCH_PREFIX + bridgeUrl;
    if (hasFreshPrefetch(key) || inFlight[bridgeUrl]) return;
    inFlight[bridgeUrl] = true;
    try {
      fetch(bridgeUrl, { credentials: 'same-origin' })
        .then(function (resp) { return resp.ok ? resp.text() : null; })
        .then(function (html) {
          if (!html) return;
          storePrefetchEntry(key, html);
        })
        .catch(function () {})
        .then(function () { delete inFlight[bridgeUrl]; });
    } catch (_) {
      delete inFlight[bridgeUrl];
    }
  }

  function prefetchCollectionUrl(href) {
    prefetchBridgeUrl(buildBridgeUrlFromCollectionUrl(href));
  }

  function anchorFromEvent(event) {
    var target = event && event.target;
    return target && target.closest ? target.closest('a[href]') : null;
  }

  function prefetchAnchor(event) {
    var anchor = anchorFromEvent(event);
    if (!anchor) return;
    prefetchCollectionUrl(anchor.href);
  }

  function prefetchMarkedLinks() {
    document.querySelectorAll('a[data-wth-prefetch-bridge="auto"]').forEach(function (anchor) {
      prefetchCollectionUrl(anchor.href);
    });
  }

  window.WTHCatalogBridgePrefetch = {
    buildBridgeUrl: buildBridgeUrl,
    buildBridgeUrlFromCollectionUrl: buildBridgeUrlFromCollectionUrl,
    prefetchBridgeUrl: prefetchBridgeUrl,
    prefetchCollectionUrl: prefetchCollectionUrl
  };

  document.addEventListener('pointerenter', prefetchAnchor, true);
  document.addEventListener('focusin', prefetchAnchor, true);
  document.addEventListener('touchstart', prefetchAnchor, true);
  // NOTE: no 'click' listener — by click time navigation is already starting,
  // so the prefetch request is almost always aborted/wasted (hover/touch
  // already covered the useful cases).

  // Boot sweep: clear expired entries left by previous pages so the prefetch
  // cache can never accumulate across a long browsing session.
  sweepPrefetchEntries();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(prefetchMarkedLinks, { timeout: 1500 });
      else setTimeout(prefetchMarkedLinks, 500);
    });
  } else if ('requestIdleCallback' in window) {
    window.requestIdleCallback(prefetchMarkedLinks, { timeout: 1500 });
  } else {
    setTimeout(prefetchMarkedLinks, 500);
  }
})();
